import { render, staticRenderFns } from "./hzCase.vue?vue&type=template&id=0a50de82&scoped=true"
import script from "./hzCase.vue?vue&type=script&lang=js"
export * from "./hzCase.vue?vue&type=script&lang=js"
import style0 from "./hzCase.vue?vue&type=style&index=0&id=0a50de82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50de82",
  null
  
)

export default component.exports